import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { LogoLockup } from "@/components/Logo";
import MotionBackdrop from "@/components/MotionBackdrop";
import { api } from "@/lib/api";

export default function PasswordReset() {
  const [stage, setStage] = useState("request");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [pw, setPw] = useState("");
  const [devToken, setDevToken] = useState("");
  const [busy, setBusy] = useState(false);

  const request = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await api.post("/auth/password-reset/request", { email });
      if (data.reset_token_dev) { setDevToken(data.reset_token_dev); setToken(data.reset_token_dev); }
      toast.success("If that email exists, a reset token was created.");
      setStage("confirm");
    } catch (err) { toast.error(err?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  const confirm = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/auth/password-reset/confirm", { token, new_password: pw });
      toast.success("Password updated. You can sign in now.");
      setStage("done");
    } catch (err) { toast.error(err?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="relative min-h-screen bg-[var(--tm-off)] flex items-center justify-center p-5 overflow-hidden">
      <MotionBackdrop />
      <div className="relative w-full max-w-md">
        <div className="flex justify-center mb-8"><Link to="/"><LogoLockup /></Link></div>
        <div className="tm-card p-7 bg-white">
          {stage === "request" && (
            <>
              <h1 className="text-2xl font-bold">Reset your password</h1>
              <p className="mt-1 text-sm text-[#3B424B]">Enter your email to receive a reset token.</p>
              <form onSubmit={request} className="mt-6 space-y-4">
                <div><label className="tm-label">Email</label><input required type="email" className="tm-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="reset-email" /></div>
                <button className="tm-btn-primary w-full" disabled={busy} data-testid="reset-request">{busy ? "Working…" : "Send reset token"}</button>
              </form>
            </>
          )}
          {stage === "confirm" && (
            <>
              <h1 className="text-2xl font-bold">Enter your new password</h1>
              {devToken && <p className="mt-2 text-xs text-[#3B424B]">Development token: <code className="font-mono">{devToken}</code></p>}
              <form onSubmit={confirm} className="mt-6 space-y-4">
                <div><label className="tm-label">Reset token</label><input required className="tm-input font-mono text-xs" value={token} onChange={(e) => setToken(e.target.value)} data-testid="reset-token" /></div>
                <div><label className="tm-label">New password</label><input required type="password" minLength={8} className="tm-input" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-new-password" /></div>
                <button className="tm-btn-primary w-full" disabled={busy} data-testid="reset-confirm">{busy ? "Working…" : "Update password"}</button>
              </form>
            </>
          )}
          {stage === "done" && (
            <div>
              <h1 className="text-2xl font-bold">Password updated</h1>
              <p className="mt-2 text-sm text-[#3B424B]">You can now sign in with your new password.</p>
              <Link to="/signin" className="tm-btn-primary w-full mt-6" data-testid="reset-done-signin">Go to sign in</Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
